import React, { createContext, useContext, useState, useCallback } from "react";
import it from "./it";

// Register additional languages here in the future (en, es, pt, fr, de).
const catalogs = { it };

const I18nContext = createContext(null);

function resolve(obj, path) {
  return path.split(".").reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), obj);
}

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("gp_lang") || "it");

  const t = useCallback(
    (key, vars) => {
      const cat = catalogs[lang] || catalogs.it;
      let val = resolve(cat, key);
      if (val === undefined) return key;
      if (typeof val === "string" && vars) {
        Object.keys(vars).forEach((k) => {
          val = val.replace(new RegExp(`\\{${k}\\}`, "g"), vars[k]);
        });
      }
      return val;
    },
    [lang]
  );

  const changeLang = useCallback((l) => {
    localStorage.setItem("gp_lang", l);
    setLang(l);
  }, []);

  return (
    <I18nContext.Provider value={{ t, lang, changeLang, languages: Object.keys(catalogs) }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useT() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useT must be used within I18nProvider");
  return ctx;
}
